import * as types from './marketVolumeShareActionType';

export const fetchMarketVolumeSharePowerBIReportRequest = () => ({
    type: types.FETCH_MARKET_VOLUME_SHARE_POWER_BI_REPORT_REQUEST
});
export const fetchMarketVolumeSharePowerBIReportSuccess = (data) => ({
    type: types.FETCH_MARKET_VOLUME_SHARE_POWER_BI_REPORT_SUCCESS,
    payload: data
});
export const fetchMarketVolumeSharePowerBIReportFailure = (error) => ({
    type: types.FETCH_MARKET_VOLUME_SHARE_POWER_BI_REPORT_FAILURE,
    payload: error
});

export const fetchMarketVolumeShareLastRefreshedRequest = () => ({
    type: types.FETCH_MARKET_VOLUME_SHARE_LAST_REFRESHED_REQUEST
});
export const fetchMarketVolumeShareLastRefreshedSuccess = (dateTime, nextRefreshDateTime = null) => ({
    type: types.FETCH_MARKET_VOLUME_SHARE_LAST_REFRESHED_SUCCESS,
    payload: { lastRefreshedDateTime: dateTime, nextRefreshDateTime }
});
export const fetchMarketVolumeShareLastRefreshedFailure = (error) => ({
    type: types.FETCH_MARKET_VOLUME_SHARE_LAST_REFRESHED_FAILURE,
    payload: error
});
